function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")

    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")

    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }
}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}


function IsFollowCategory() {
    if ($(".BannerProductList .Product .QuickLookLikeBtn").length <= 0) {
        return;
    }
    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/ProductDetails/IsFollowAll",
        dataType: 'json',
        async: true,
        success: function (dt) {
            updateList(dt);
        }
    });

    var updateList = function (dt) {
        $(".BannerProductList .Product .QuickLookLikeBtn").removeClass("active");

        for (var i in dt) {
            var item = dt[i];

            var followlar = $(".BannerProductList .Product .QuickLookLikeBtn").filter(function (index) {
                return $(this).attr("data-id") == item["ProductID"] && $(this).attr("data-colorid") == item["ColorID"];
            });

            if (followlar.length > 0) {
                var followItem = $(followlar[0]);
                followItem.addClass("active");
                followItem.find(".sorsfont").removeClass("sorsfont-Star").addClass("sorsfont-Star-fill");

                    //if (followItem.hasClass("active")) {
                //    followItem.children("img").attr("src", "/Images/OXNW/like_full.svg");
                //}
                followItem.children("img").attr("src", "/Images/OS/Heart_black.svg");
            }
        }
    };
}

function FollowProperties() {
    $(document).on("click", ".BannerProductList .QuickLookLikeBtn:not(.active)", function () {

        var ProductID = $($(this)).attr("data-id");
        var ColorID = $($(this)).attr("data-colorid");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");

        AddToFavorite(ColorID, ProductID, function (result, msg) {
            if (result == true) {
                button.addClass("active");
                button.find(".sorsfont").removeClass("sorsfont-Star").addClass("sorsfont-Star-fill");

                //favorilere eklenince kalp siyah
                button.find(".heart-icon").attr("src", "/images/OS/Heart_black.svg");
            }
            else {
                var loginLink = getRequestRoute() + "/p/User/Login";

                SwalGenerate("warning", msg, "Favorilere Eklenemedi", "<a class='loginbtn'>" + getStandartMessages("GirisYap") + "</a>");
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });

    $(document).on("click", ".BannerProductList .QuickLookLikeBtn.active", function () {
        var ProductID = $($(this)).attr("data-id");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");

        removeFavorite(ProductID, function (result) {
            if (result == true) {
                button.removeClass("active");
                button.find(".sorsfont").removeClass("sorsfont-Star-fill").addClass("sorsfont-Star");

                //favorilerden çıkarınca kalp ilk haline dönüyor
                button.find(".heart-icon").attr("src", "/images/OS/Heart.svg");
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });
}

function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: getRequestRoute() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }
                }
            }

            settingTextBanner();
        }
    });
}

function Instagram() {
    if ($(".InstagramContainer .InstagramBody .InstagramItem").length > 0) {
        $(document).on("click", ".InstagramContainer .InstagramBody .InstagramItem > a", function () {
            var MediaID = $(this).attr("data-media");

            if (MediaID != null && MediaID != "" && MediaID != undefined) {
                CurrentLink = $(this);
                GenerateLocalLoading(CurrentLink.find(".ImageArea"), "show");

                GetMediaDetail(MediaID, function (dt) {
                    if (dt != null && dt != false) {

                        InstagramModal = $("#InstagramModal");
                        InstagramModal.find(".modal-body article .LeftArea .ImageArea img").attr("src", dt.MediaURL);
                        InstagramModal.find(".modal-body article .RightArea .description").html(dt.Caption);
                        InstagramModal.find(".modal-body article .RightArea .TimeStamp").html(dt.FormatDate);

                        InstagramModal.modal("show");
                    }

                    GenerateLocalLoading(CurrentLink.find(".ImageArea"), "hide");
                });
            }

        });
    }

    function GetMediaDetail(MediaID, callback) {
        $.ajax({
            type: 'GET',
            url: getRequestRoute() + "/p/Home/GetInstagramMediaDetail?MediaID=" + MediaID,
            cache: false,
            contentType: 'application/json; charset=utf-8',
            success: function (dt) {
                callback(dt);
            },
            error: function () {
                callback(false);
            }
        });
    }
}

$(document).ready(function () {
    FollowProperties();
    settingTextBanner();
    GetLayoutTextBanners();
    Instagram();
    if (!isMobileResolution()) {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".mobile-section").length > 0) {
                caruselInner = $(this).find(".mobile-section").closest(".carousel-inner");

                //$(this).find(".mobile-section").closest(".carousel-item").remove();
                caruselInner.find(".carousel-item").first().addClass("active");
            }

            //if ($(this).find(".carousel-inner .carousel-item").length <= 1) {
            //    $(this).find("> a").remove();
            //}
        });
    }
    else {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".desktop-section").length > 0) {
                caruselInner = $(this).find(".desktop-section").closest(".carousel-inner");

                //$(this).find(".desktop-section").closest(".carousel-item").remove();
                caruselInner.find(".carousel-item").first().addClass("active");
            }

            //if ($(this).find(".carousel-inner .carousel-item").length <= 1) {
            //    $(this).find("> a").remove();
            //}
        });
    }

    $(document).on("click", "#Anasayfa1 .ScrollDown i", function () {
        var height = $("#HomeBannerSection #Anasayfa1").height();

        $("html, body").animate({ scrollTop: height }, 500, 'swing');
    });

    if ($("body.home .HomeProducts .ProductList .Prd").length > 0) {
        $("body.home .ProductList .Prd img.PImage").Lazy();
    }
     
    if ($('#RegisterCampaignModal').length > 0 && $('body').hasClass("home")) {
        $('#RegisterCampaignModal').modal("show"); 
    }
  
    $(document).on("click", "#whatsapInfo .closeIcon .sorsfont-close", function () {
        document.getElementById("whatsapInfo").style.display = "none";
    });
    $(document).on("click", ".SellWithUs #Phone2", function () {
        if ($(".SellWithUs #Phone2").val().length < 1) {
            $('.SellWithUs #Phone2').val('0');
        }
       
      
        $(".SellWithUs #Phone2").mask("Z99 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[1-9]/, //optional: true
                }
            }
        });
        
        //$(this).val(phone);
    });
});
